export default __webpack_public_path__ + "static/media/ais_bottom_logo@2x.fe05a627.webp";